/** Small mono note (estimates, caveats). */
export function Note({ text }: { text: string }) {
  return <p className="note">{text}</p>
}
